import '../styles/newRequest.css';
import React, { useEffect, useState } from 'react';
import { Spinner,DatePicker,mergeStyleSets} from '@fluentui/react';
import { useNavigate } from 'react-router-dom';
import FileUpload from '../components/FileUpload';
import { useApiService } from '../services/apiServices';
import { toast } from 'react-toastify';
import { parseISO, format } from "date-fns";

const initialFormInputsValues = {
    deponentName: "",
    courtId: "",
    isTranslatorRequired: "",
    appointmentDate: "",
    courtDivisionId: ""
}

const currentDate = new Date();

const NewRequest = () => {
    const handleApiRequest = useApiService();
    const navigate = useNavigate();

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const [courts, setCourts] = useState([]);
    const [courtDivisions, setCourtDivisions] = useState([]);

    const [formInputs, setFormInputs] = useState(initialFormInputsValues);
    const [courtDivisionsForCourt, setCourtDivisionsForCourt] = useState([]);
    const [file, setFile] = useState(null);
    const [resetFileComponentState, setResetFileComponentState] = useState(0);

    const handleResetFileComponentState = () => {
        setResetFileComponentState((prevKey) => prevKey + 1);
    };

    useEffect(() => {
        const fetchCourtData = async () => {
            try {
                const courtResponse = handleApiRequest(
                    `${process.env.REACT_APP_API_BASE_URL}/court/all`,
                    "GET"
                );

                const courtDivisionResponse = handleApiRequest(
                    `${process.env.REACT_APP_API_BASE_URL}/court/divisions/all`,
                    "GET"
                );

                setCourts(await courtResponse);
                setCourtDivisions(await courtDivisionResponse);
            } catch (error) {
                console.error("Failed to fetch data:", error);
            }
        };

        fetchCourtData();
    }, []);

    const validateFormInputs = () => {
        if (formInputs.deponentName && formInputs.appointmentDate && formInputs.courtId && formInputs.courtDivisionId && formInputs.isTranslatorRequired && file) {
            setIsFormValid(true);
        } else {
            setIsFormValid(false);
        }
    }
    const handleDateFormInputChange = (name, date) => {
            if (date) {
                setFormInputs({ ...formInputs, [name]: format(date, "yyyy-MM-dd") });
            }
        };
    const handleFormInputChange = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;

        if (inputName === "courtId") {
            setFormInputs({ ...formInputs, [inputName]: inputValue, courtDivisionId: "" }); // set court and reset the court division when court name changes
            const courtDivisionsForSelectedCourt = courtDivisions.filter((division) => division.courtId === parseInt(inputValue));
            setCourtDivisionsForCourt(courtDivisionsForSelectedCourt);
        } else {
            setFormInputs({ ...formInputs, [inputName]: inputValue });
        }

        validateFormInputs();
    }

    const handleFileChange = (file) => {
        setFile(file);
        validateFormInputs();
    }


    const handleFormSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
        if (!validateFormInputs()) {
            formInputs.fileAttachment = file;
            const formData = new FormData();
            for (const key in formInputs) {
                formData.append(key, formInputs[key]);
            }
            const result = await handleApiRequest(
                `${process.env.REACT_APP_API_BASE_URL}/affidavit/create`,
                "POST",
                formData
            );

            if(result && result.isSuccess === true)
                 {
                    const documentId = result?.content;
                    sessionStorage.setItem("documentId", documentId);
                    setFormInputs(initialFormInputsValues);
                    setFile(null);
                    handleResetFileComponentState();
                    navigate('/success');
                 }else{
                    toast.error("Failed to submit form. Please try again later.");   
                 }
        } else {
            toast.error("Please ensure all form fields are filled.")
            throw new Error("Please ensure all form fields are filled.");
            
        }
    } catch (error) {
        console.error("Form submission error:", error);
        toast.error("Failed to submit form. Please try again later.");   
    } finally {
        setIsSubmitting(false);
    }
};


    return (
        <div style={{ background: "#fff" , height: '100%'}}>
             <div className="page-title">
                <p>Affidavit Application</p>
            </div>
            <form style={{backgroundColor: '#fff' }}>
                <div className='form-wrapper'>
                    <div className='nr-form-container'>
                        <div className='nr-form-inputs-container'>
                            <div className='section'>
                                <div className='input-container'>
                                    <label htmlFor="deponentName">Deponent’s name:</label>
                                    <input
                                        type="text"
                                        name="deponentName"
                                        id="deponentName"
                                        value={formInputs.deponentName}
                                        placeholder="Please enter Deponent's name"
                                        onChange={handleFormInputChange}
                                    />
                                </div>
                                <div className='input-container'>
                                    <label htmlFor="courtId">Court name:</label>
                                   
                                    <select
                                        name="courtId"
                                        id="courtId"
                                        value={formInputs.courtId}
                                        required
                                        onChange={handleFormInputChange}
                                    >
                                        <option value="" disabled hidden >
                                            Please select a court name
                                        </option>
                                        {courts.map((court) => {
                                            return <option value={court.id} key={court.id}>{court.courtName}</option>
                                        })}
                                    </select>
                                </div>
                                <div className='input-container'>
                                    <label htmlFor="isTranslatorRequired">Translator Required?</label>
                                    <select
                                        name="isTranslatorRequired"
                                        id="isTranslatorRequired"
                                        value={formInputs.isTranslatorRequired}
                                        required
                                        onChange={handleFormInputChange}
                                    >
                          -              <option value="" disabled hidden>
                                            Please select an option
                                        </option>
                                        <option value={"Yes"} key={1}>
                                            Yes
                                        </option>
                                        <option value={"No"} key={2}>
                                            No
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div className='section1'>
                                <div className='input-container1'>
                                    <label htmlFor="appointmentDate" style={{float: 'left'}}>Appointment Date:</label>
                                    <DatePicker
                                        placeholder='dd-mmm-yyyy'
                                        id="appointmentDate"
                                        style={{textAlign:'left'}}
                                        formatDate={(date) => format(date, "dd-MMM-yyyy")}
                                        value={formInputs.appointmentDate ? parseISO(formInputs.appointmentDate) : null}
                                        onSelectDate={(date) => handleDateFormInputChange("appointmentDate", date)}                      
                                        minDate={currentDate}
                                        className="custom-datepicker"
                                        borderless
                                    />
                                </div>
                                <div className='input-container1'>
                                    <label htmlFor="courtDivisionId">Court Division:</label>
                                    <select
                                        name="courtDivisionId"
                                        id="courtDivisionId"
                                        value={formInputs.courtDivisionId}
                                        required
                                        onChange={handleFormInputChange}
                                        disabled={!formInputs.courtId}
                                    >
                                        <option value="" disabled hidden>
                                            Please select a court division
                                        </option>
                                        {courtDivisionsForCourt.map((division) => {
                                            return <option value={division.id} key={division.id}>{division.courtDivisionName}</option>
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <FileUpload onFileSelected={handleFileChange} key={resetFileComponentState}/>
                    </div>

                    <div className='nr-form-button-wrapper'>
                        <button
                            type="submit"
                            className="submit-btn"
                            onClick={handleFormSubmit}
                            disabled={isSubmitting ? true : !isFormValid}
                        >Submit {isSubmitting ? <span><Spinner /></span> : ""}</button>
                    </div>
                </div>
            </form>
        </div>
    )
};

export default NewRequest;